import html2canvas from 'html2canvas';

export const copyInsight = (
  graphElement: HTMLDivElement,
  textBefore: string,
  textAfter = '',
  subject = ''
): Promise<void> =>
  new Promise((resolve, reject) => {
    const selection = window.getSelection();
    if (!selection) {
      return reject(new Error('No selection'));
    }

    if (selection.rangeCount > 0) {
      selection.removeAllRanges();
    }

    const range = document.createRange();

    html2canvas(graphElement, { backgroundColor: '#ffffff', useCORS: true })
      .then((canvas) => {
        const dataUrl = canvas.toDataURL('image/jpeg', 1);
        const img = document.createElement('img');
        const copyContainer = document.createElement('div');
        copyContainer.style.backgroundColor = 'white';
        copyContainer.style.fontSize = '14px';

        img.onload = () => {
          range.selectNode(copyContainer);
          selection.addRange(range);
          document.execCommand('copy');
          selection.removeAllRanges();
          document.body.removeChild(copyContainer);
          resolve();
        };

        img.id = 'similarweb-insight';
        img.src = dataUrl;

        if (subject) {
          const bold = document.createElement('b');
          bold.textContent = `Subject: ${subject}`;
          copyContainer.appendChild(bold);
          copyContainer.appendChild(document.createElement('br'));
          copyContainer.appendChild(document.createElement('br'));
        }
        copyContainer.appendChild(document.createTextNode(textBefore));
        copyContainer.appendChild(document.createElement('br'));
        copyContainer.appendChild(img);
        if (textAfter) {
          copyContainer.appendChild(document.createElement('br'));
          copyContainer.appendChild(document.createTextNode(textAfter));
        }
        document.body.appendChild(copyContainer);
      })
      .catch(reject);
  });
